module.exports = __webpack_public_path__ + "img/CellCycle-PRCA_10X_ANS.41e9b4e4.png";